var _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_7",
    "data-name": "Component 2 \u2013 7",
    viewBox: "0 0 53 53"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#4c4c4c"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 9,
    y1: 11,
    transform: "translate(21.392 21.191)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    y1: 11,
    x2: 9,
    transform: "translate(21.392 21.191)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
};
export default __webpack_public_path__ + "static/media/cancel_button.9c5731a6.svg";
export { SvgComponent as ReactComponent };